import { generaLivello } from "./utility.js";
export default function secondoLivello(k) {
    k.scene("secondoLivello", () => {
        const LIVELLO = [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            " @     ^  $$$$  ^            >",
            " =================   ==   ===",
        ];
        generaLivello(k, LIVELLO, "terzoLivello");
        k.add([
            color(255, 0, 0),
            text("ATTENZIONE! IL BAMBOO MARRONE NON VA TOCCATO "),
            anchor("center"),
            pos(width() / 2, 100),
            fixed(),
        ])
    });
}